module.exports = __webpack_public_path__ + "media/images/sagatsuku-kun-37b6f8605a49b7fd9da823466acca78d.gif";